import LottieView from 'lottie-react-native'
import { View } from 'react-native'
import { Text, useWindowDimensions, XStack, YStack } from 'tamagui'

const ANIMATION_SIZE = 200

export function OfflineCoverPage() {
  const { height } = useWindowDimensions()

  const paddingTop = height * 0.15

  return (
    <YStack ai="center" h="100%" bg="$bg-page" pt={paddingTop}>
      <XStack paddingHorizontal="$spacing-inset-xs">
        <YStack
          ai="center"
          gap="$spacing-inset-sm"
          paddingHorizontal="$spacing-inset-sm"
        >
          <View style={{ width: ANIMATION_SIZE, height: ANIMATION_SIZE }}>
            <LottieView
              source={require('@assets/animations/offline.json')}
              autoPlay
              loop
              resizeMode="cover"
              style={{ width: ANIMATION_SIZE, height: ANIMATION_SIZE }}
            />
          </View>

          <YStack gap="$spacing-inset-xs" paddingHorizontal={20}>
            <YStack>
              <Text
                ff="$mulishRegular"
                fontSize="$font-size-md"
                color="$text-primary"
                fontWeight="700"
                textAlign="center"
              >
                Parece que você está
              </Text>
              <Text
                ff="$mulishRegular"
                fontSize="$font-size-md"
                color="$text-primary"
                fontWeight="700"
                textAlign="center"
              >
                sem conexão
              </Text>
            </YStack>

            <YStack>
              <Text
                ff="$mulishRegular"
                fontSize="$font-size-xs"
                color="$text-primary"
                textAlign="center"
                fontWeight="300"
              >
                Verifique sua rede e tente novamente
              </Text>

              <Text
                ff="$mulishRegular"
                fontSize="$font-size-xs"
                color="$text-primary"
                textAlign="center"
                fontWeight="300"
              >
                mais tarde.
              </Text>
            </YStack>
          </YStack>
        </YStack>
      </XStack>
    </YStack>
  )
}
